<div class="row">

  <div class="col-1 text-md-start">
    <button class="btn btn-secondary mt-1" (click)="returnToDeliveryStatusView()"> Back </button>
  </div>
  <div class="col-11 mogo-bold">
    <h1>
      @if (jobId === null) {
      <p>
        Create Job
      </p>

      } @else {
      <p>
        Editing Job
      </p>
      }
    </h1>
  </div>

</div>

<app-jobbing-upsert-form [jobId]="jobId"></app-jobbing-upsert-form>
